import React from "react";
import styles from "../../styles/evento-detalle.module.css";

export function ReadOnlyInput({ value }) {
    return <input value={value ?? ""} readOnly disabled className={styles.input} />;
}

export function ReadOnlyTextarea({ value }) {
    return <textarea value={value ?? ""} readOnly disabled className={styles.textarea} />;
}
